import { InflateRequestMode } from '@sccs/types';
import { pipe, rawTransform } from 'valibot';
import { MixedT4Data } from '../../types/GeneralTypes';
import { MixedDlsTeaserResponse } from '../../types/dls/dls-response/ProductDto';
import { SchemaAny } from '../VehicleTileDataSchema';

export const ConvertT4ToDlsTransformer = pipe(
  SchemaAny,
  rawTransform<MixedT4Data, MixedDlsTeaserResponse>(({ dataset, addIssue, NEVER }) => {
    if (!dataset || !dataset.value) {
      addIssue({
        message: 'issues in ConvertT4ToDlsTransformer',
        path: [
          {
            type: 'object',
            origin: 'value',
            input: dataset.value as unknown as Record<string, unknown>,
            key: 'results',
            value: dataset.value,
          },
        ],
      });
      return NEVER;
    }
    const vehicle = dataset.value.personalizedVehicle.vehicleData;
    const badges = dataset.value.personalizedVehicle.translationData;
    if (!badges.recommendationBadge) {
      addIssue({
        message: 'Recommendation badge is not available',
        path: [
          {
            type: 'object',
            origin: 'value',
            input: dataset.value as Record<string, unknown>,
            key: 'results',
            value: dataset.value,
          },
        ],
      });
      return NEVER;
    }
    if (!vehicle.localEmissionAndConsumptionData) {
      addIssue({
        message: 'Local emission and consumption data is not available',
        path: [
          {
            type: 'object',
            origin: 'value',
            input: dataset.value as Record<string, unknown>,
            key: 'results',
            value: dataset.value,
          },
        ],
      });
      return NEVER;
    }
    return {
      ...vehicle,
      badges: [
        {
          name: badges.recommendationBadge.name,
          description: badges.recommendationBadge.description,
          footnote: badges.recommendationBadge.footnote,
        },
      ],
      localEmissionAndConsumptionData: JSON.stringify(vehicle.localEmissionAndConsumptionData),
      responseTypeId: 'ProductDto',
      market: dataset.value.market,
      lang: dataset.value.lang,
      brand: dataset.value.brand,
      mode: InflateRequestMode.PERSONALIZED_T4,
      translations: dataset.value.translations,
    };
  }),
);
